function handleHeadlessLink(url = '') {
  const linkArray = url.split('/pages/');
  if (url.includes('compliance.carlsberggroup')) {
    return url;
  }
  return `/pages/${linkArray.slice(1, linkArray.length).join('/')}`;
}

export { handleHeadlessLink };
